import { notification } from "antd";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import CharacterTable from "../../components/Character/CharacterTable";
import EpisodeTable from "../../components/Episode/EpisodeTable";
import PageTitle from "../../components/PageTitle";
import { getStoryDetail } from "../../helpers/api/story";

const StoryDetail = () => {

  const { storyId } = useParams();

  const [story, setStory] = useState<any>(null);

  const [api, contextHolder] = notification.useNotification();

  const showError = (errorMessage: string) => {
    api.error({
      message: `Error notification`,
      description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
      placement: 'topRight'
    });
  }

  useEffect(() => {
    if (!storyId) {
      return;
    }
    getStoryDetailById();
  }, [storyId]);

  const getStoryDetailById = async () => {
    try {
      const res = await getStoryDetail(storyId as string);
      setStory(res.data.data);
    } catch (err) {
      console.error(err);
      showError(err as string);
    }
  }

  return (
    story && (<>
      {contextHolder}

      <PageTitle
        breadCrumbItems={[
          { label: "Stories", path: "/stories", active: false },
          { label: "Stories detail", path: "/stories/" + storyId, active: true },
        ]}
        title={<span><span className="text-danger">{story.name}</span> story</span>}
      />

      <Row>
        <Col>
          <CharacterTable story={story} />
          <EpisodeTable story={story} />
        </Col>
      </Row>
    </>)
  );
};

export default StoryDetail;
